import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    isInitialFetchComplete: false,
    error: false,
    // we can search by activity parent types
    entities: {
        running: [],
        cycling: [],
        hiking: [],
        strength_training: [],
        swimming: [],
        other: [],
        yoga: [],
        diving: [],
        favorites: {
            running: [],
            cycling: [],
            hiking: [],
            strength_training: [],
            swimming: [],
            other: [],
            yoga: [],
            diving: []
        }
    }
};

const requestActivitiesBySearch = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveActivitiesBySearchError = (state, action) => {
    return {
        ...state,
        error: true,
        isInitialFetchComplete: true,
        lastUpdated: action.receivedAt
    };
};

const receiveActivitiesBySearch = (state, action) => {
    if (!action.favorite) {
        return {
            ...state,
            isFetching: false,
            isInitialFetchComplete: true,
            error: false,
            entities: {
                ...state.entities,
                [action.parentActivityType]: [...state.entities[action.parentActivityType], ...action.activities] || []
            },
            lastUpdated: action.receivedAt
        };
    } else {
        return {
            ...state,
            isFetching: false,
            isInitialFetchComplete: true,
            error: false,
            entities: {
                ...state.entities,
                favorites: {
                    ...state.entities.favorites,
                    [action.parentActivityType]: action.activities || []
                }
            },
            lastUpdated: action.receivedAt
        };
    }
};

const receiveFavoriteActivity = (state, action) => {
    const activityTypeListIndex = state.entities[action.parentActivityType].findIndex(
        (x) => x.activityId === action.activityDetails.activityId
    );
    const favoriteActivityTypeListIndex = state.entities.favorites[action.parentActivityType].findIndex(
        (x) => x.activityId === action.activityDetails.activityId
    );

    //update the favorite field in the activity type list
    state.entities[action.parentActivityType][activityTypeListIndex].favorite = action.favorite;

    if (!action.favorite) {
        //remove item from the favorites list
        state.entities.favorites[action.parentActivityType].splice(favoriteActivityTypeListIndex, 1);
    } else {
        //add item to the favorites list
        state.entities.favorites[action.parentActivityType].push(action.activityDetails);
    }

    return {
        ...state,
        isFetching: false,
        entities: {
            ...state.entities,
            favorites: {
                ...state.entities.favorites,
                [action.parentActivityType]: state.entities.favorites[action.parentActivityType]
            }
        },
        lastUpdated: action.receivedAt
    };
};

const receiveDeleteActivity = (state, action) => {
    const activityTypeListIndex = state.entities[action.parentActivityType].findIndex(
        (x) => x.activityId === action.activityDetails.activityId
    );
    const favoriteActivityTypeListIndex = state.entities.favorites[action.parentActivityType].findIndex(
        (x) => x.activityId === action.activityDetails.activityId
    );

    if (action.activityDetails.favorite) {
        //remove item from the favorites list
        state.entities.favorites[action.parentActivityType].splice(favoriteActivityTypeListIndex, 1);
    }

    //remove item from the activity list
    state.entities[action.parentActivityType].splice(activityTypeListIndex, 1);

    return {
        ...state,
        isFetching: false,
        entities: {
            ...state.entities,
            [action.parentActivityType]: state.entities[action.parentActivityType],
            favorites: {
                ...state.entities.favorites,
                [action.parentActivityType]: state.entities.favorites[action.parentActivityType]
            }
        },
        lastUpdated: action.receivedAt
    };
};

const resetActivitiesBySearch = () => INITIAL_STATE;

const handlers = {
    [types.REQUEST_ACTIVITIES_BY_SEARCH]: requestActivitiesBySearch,
    [types.RECEIVE_ACTIVITIES_BY_SEARCH]: receiveActivitiesBySearch,
    [types.RECEIVE_FAVORITE_ACTIVITY]: receiveFavoriteActivity,
    [types.RECEIVE_DELETE_ACTIVITY_BY_SEARCH]: receiveDeleteActivity,
    [types.RECEIVE_ACTIVITIES_BY_SEARCH_ERROR]: receiveActivitiesBySearchError,
    [types.RESET_ACTIVITIES_BY_SEARCH]: resetActivitiesBySearch
};

export const getActivities = (state) => state.activitySearch;

export default function activitySearch(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
